import styled, { createGlobalStyle } from 'styled-components'
import { CampaignStatus } from 'Constants/enums'
import variables, { colors, device } from 'Styled/variables'
import { Progress } from 'antd'
import DefaultCover from 'Shared/img/svg/defaultCover.svg'

interface Props {
  status: string
}

const handleStatusColor = (status: string) => {
  switch (status) {
    case CampaignStatus.PENDING_APPROVAL:
    case CampaignStatus.AWAITING_REVIEW:
      return colors.messegesYellow1

    case CampaignStatus.APPROVED:
    case CampaignStatus.PENDING:
      return colors.messegesGreen1

    case CampaignStatus.ENDED:
    case CampaignStatus.FINISHED:
    case CampaignStatus.CANCELED:
      return colors.messegesRed

    case CampaignStatus.STOPPED:
      return colors.greyTextWhiteBg

    default:
      return colors.mainText
  }
}

const handleStatusGrid = (status: string) => {
  switch (status) {
    case CampaignStatus.PENDING_APPROVAL:
    case CampaignStatus.AWAITING_REVIEW:
      return 'repeat(4, minmax(0, auto))'

    case CampaignStatus.APPROVED:
    case CampaignStatus.PENDING:
      return 'repeat(4, minmax(0, auto))'

    case CampaignStatus.ENDED:
    case CampaignStatus.FINISHED:
    case CampaignStatus.CANCELED:
    case CampaignStatus.STOPPED:
      // TODO: need to clarify with Lilya why this condition did exist in the first place
      return 'repeat(4, minmax(0, auto))'

    default:
      return 'repeat(4, minmax(0, auto))'
  }
}

export const RelaunchButtonWrapper = styled.div`
  margin-top: 10px;
`

export const CardBody = styled.div`
  background-color: ${colors.white};
  padding: 20px;
  border-radius: 5px;
  flex: 1 1 auto;
  min-height: 1px;
`

export const StyledTd = styled.td`
  font-size: 14px !important;
  text-transform: capitalize;
  color: #58b660;
`

export const StyledLi = styled.li`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-template-rows: ${(props: Props) => handleStatusGrid(props.status)};
  gap: 16px;
  align-items: start;
  padding: 24px;
  margin-bottom: 8px;
  background-color: ${colors.white};
  border-radius: 4px;
  @media ${device.mobileMin} {
    grid-template-rows: repeat(4, minmax(0, auto));
  }
  @media ${device.smallScreen} {
    grid-template-columns: 80px 218px 180px 120px 200px;
    justify-content: space-between;
    grid-template-rows: none;
    align-items: center;
    background-color: ${colors.greyBg};
    margin-bottom: 2px;
  }
`

export const StyledIcon = styled.div`
  display: grid;
  gap: 30px;
  justify-items: center;
  align-items: center;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-row: 1 / -1;
  @media ${device.smallScreen} {
    grid-auto-flow: column;
    gap: 16px;
  }
`

export const StyledBtn = styled.div`
  display: grid;
  grid-template-columns: auto 40px;
  justify-items: start;
  justify-content: start;
  gap: 8px;
  @media ${device.smallScreen} {
    gap: 14px;
  }
`

export const StyledItem = styled.div`
  line-height: 19px;
`

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  @media ${device.smallScreen} {
    grid-column-start: 1;
  }
`

export const ImgWrapper = styled.div`
  padding-top: 3px;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 4px;
  & img {
    border-radius: 4px;
  }
  @media ${device.smallScreen} {
    padding-top: 0px;
  }
`

export const RoundBtn = styled.button`
  background: ${colors.white};
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
`

export const NamesWrapper = styled.div`
  display: grid;
  gap: 4px;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  color: ${colors.mainText};
  @media ${device.smallScreen} {
    gap: 4px;
  }
  @media ${device.mobileMax} {
    gap: 16px;
  }
`

export const Name = styled.div`
  font-weight: 600;
`

export const Artist = styled.div`
  @media ${device.smallScreen} {
    font-size: ${variables.fontSize14};
  }
`
export const DateWrapper = styled.div`
  display: grid;
  @media ${device.smallScreen} {
    justify-content: center;
  }
`

export const Status = styled.div`
  //text-transform: capitalize;
  color: ${(props: Props) => handleStatusColor(props.status)};

  @media ${device.smallScreen} {
    text-align: center;
  }
`

export const StyledProgress = styled(Progress)`
  padding-top: 6px;
  .ant-progress-steps-item {
    width: 8px !important;
  }
`

export const Text = styled.div`
  font-size: ${variables.fontSize10};
  line-height: 15px;
`

export const Reviews = styled.div`
  text-transform: lowercase;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`

export const StyledPopover = styled.div``

export const GlobalStyled = createGlobalStyle`
 .ant-popover-arrow{
  display: none !important;
 }
 .ant-popover-inner-content{
    padding: 16px;
  }
  .ant-popover-inner {
    width: 288px
  }
`

export const Wrapper = styled.div`
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`
export const StyledTitle = styled.div`
  padding-bottom: 16px;
`

export const BtnsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const MobileFieldTitle = styled.div`
  display: none;
  font-size: 10px;
  line-height: 150%;
  color: ${colors.mainText};

  @media ${device.mobileMax} {
    display: block;
  }
`
